<template>
  <div class="AllSigned">
    <p>
      Datum waarop alle partijen het PVO hebben getekend. Zodra deze datum is ingevoerd en opgeslagen worden alle laadpunten in deze aanvraag op status ‘in bedrijf’ gezet.
    </p>
    <FieldSet
      :label="label"
      :values="values"
      :fields="fields"
      :validation="validation"
      :layout="layout"
      :disabled="disabled"
      :path="path"
    />
  </div>
</template>

<script>
import FieldSet from '@/components/form/FieldSet'

// import { required } from 'vuelidate/lib/validators'

export default {
  name: 'GridConnection',
  components: { FieldSet },
  props: {
    label: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default: function() {
        return {}
      },
    },
    path: {
      type: String,
      default: 'Progress',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Copied from Cafienne
      fields: {
        'AllPartiesSignedDate': {
            'type': 'string',
            'title': '',
            'format': 'date',
        },
      },
      layout: [{
        'columns': '1fr 1fr',
        'fields': ['AllPartiesSignedDate'],
      }],
      validation: {},
    }
  },
}
</script>
